import { render, staticRenderFns } from "./RefundDetail.vue?vue&type=template&id=65a6ee7a&scoped=true&"
import script from "./RefundDetail.vue?vue&type=script&lang=js&"
export * from "./RefundDetail.vue?vue&type=script&lang=js&"
import style0 from "./RefundDetail.vue?vue&type=style&index=0&id=65a6ee7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a6ee7a",
  null
  
)

export default component.exports